import { axiosConfig } from "../../../../../lib/AxiosConfig";

export const getAllBuilderCompanies = () => {
    return new Promise(async function (resolve, reject) {
        try{
            let allBuilders = axiosConfig.get("/buildercompany/getallbuildcompanies");
            
            console.log(allBuilders);
            resolve(allBuilders);
            return allBuilders;
        }catch(e){
            console.log(e);
            reject(Error("It broke"));
        }
    });
};



export const postNewBuilderHQCompany = (buildertoPost) =>{
    return new Promise(async function (resolve, reject) {
        try{
            let newBuilderResp = axiosConfig.post("/buildercompany/postNewBuildCompany",buildertoPost);
            console.log(newBuilderResp);
            resolve(newBuilderResp);
            return newBuilderResp;
        }catch(e){
            console.log(e);
            reject(Error("It broke"));
        }
    });
};


export const patchBuilder = (bankToPatch) => {
    return new Promise (async function (resolve,reject){
        try{
            let patchBuilderResponse = axiosConfig.patch("/buildercompany/updatebuildcompany",bankToPatch);
            resolve(patchBuilderResponse)

        }catch(e){
            console.log(e);
            reject(Error("it broke"))
        }
    })
};


/**
 * BRANCHES
 */

export const postNewBuildBranch = (buildBranchToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBuildBranchResponse = axiosConfig.post("/buildbranch/postnewbranch",buildBranchToPost);
            resolve(postedBuildBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
}


export const patchBuildBranch = (buildBranchToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedBuildBranchResponse = axiosConfig.post("/buildbranch/updatebuildbranch",buildBranchToPatch);
            resolve(patchedBuildBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


/**
 * BRANCHES
 */

export const postNewBuilderBranchEE = (builderBranchEEToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBuilderEEResponse = axiosConfig.post("/users/newUser",builderBranchEEToPost);
            resolve(postedBuilderEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};

export const patchBuilderBranchEE = (builderBranchEEToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedBuilderBranchEEResponse = axiosConfig.patch("/users/patchupdateUser",builderBranchEEToPatch);
            resolve(patchedBuilderBranchEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};